// Angular
import { Component, Input, OnChanges, SecurityContext } from '@angular/core';

// Afidium
import { IRulePenalty  } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { LabelService } from 'libraries/service/label/label.service';
import { PriceRealAmountPipe } from 'libraries/pipes/price/priceRealAmount.pipe';
import { IMomentDateFormat } from 'libraries/interfaces/IMomentDateFormat';
import { wenji } from 'libraries/interfaces/IWenji';
import { DateMomentPipe } from 'libraries/date/dateMoment.pipe';
import { ITotal } from 'libraries/interfaces/ITotal';
import { DomSanitizer } from '@angular/platform-browser';


enum Exchange {
    beforeDeparture = 'beforeDeparture',
    afterDeparture = 'afterDeparture',
    noShow = 'noShow'
}

enum Icon {
    unlock = 'fa-unlock-alt',
    lock = 'fa-lock',
}

@Component({
    selector: 'exchange',
    template: `
        <fa-icon [icon]="icon | iconNameToDefinition"></fa-icon>
        <span [innerHTML]="cancellation"></span>
    `
})
export class ExchangeComponent implements OnChanges {
    @Input()
    public exchange: IRulePenalty;

    @Input()
    public total: ITotal;

    public cancellation: string;
    public icon: Icon = Icon.unlock;
    public dateFormat: IMomentDateFormat = JSON.parse(wenji.ui.dateFormat);

    constructor(
        private readonly priceRealAmountPipe: PriceRealAmountPipe,
        private readonly labelService: LabelService,
        private readonly dateMomentPipe: DateMomentPipe,
        private readonly domSanitizer: DomSanitizer,
    ) { }

    public ngOnChanges(): void {
        if (this.exchange.percentage) {
            this.cancellation = this.labelService.completeLabel(Yii.t('wui-shared-js',
                `<strong>%price%</strong> de frais d'annulation (%percentage%%)`), {
                'price': this.domSanitizer.sanitize(
                    SecurityContext.HTML, 
                    this.priceRealAmountPipe
                        .transform(this.total.amount * this.exchange.percentage / 100, this.total.currency)
                ),
                'percentage': this.exchange.percentage
            });
        } else {
            if (this.exchange.validity.exchange && this.exchange.validity.exchange.countingFrom) {
                this.icon = Icon.unlock;

                this.exchange.validity.exchange.countingFrom === Exchange.beforeDeparture ?
                    this.cancellation = this.completeLabel("avec <strong>%value%</strong> de frais d'annulation avant le départ",
                        { value: this.exchange.unitAmount },
                        this.exchange.currency)
                    :
                    this.cancellation = this.completeLabel("avec <strong>%value%</strong> de frais d'annulation après le départ",
                        { value: this.exchange.unitAmount },
                        this.exchange.currency);
            } else {
                const validityDate: Date = new Date(this.exchange.validity.cancellation.end);
                const currentDate: Date = new Date();

                this.icon = validityDate < currentDate ? Icon.unlock : Icon.lock;

                this.cancellation = this.completeLabel("avec <strong>%value%</strong> de frais d'annulation jusqu'au <strong>%date%</strong>",
                    { value: this.exchange.unitAmount, date: this.dateMomentPipe.transform(validityDate, this.dateFormat.momentMedium) },
                    this.exchange.currency);
            }
        }
    }

    private completeLabel(sentence: string, amount: { value: number; date?: string }, currency: string): string {
        return this.labelService
            .completeLabel(sentence, {
                value: this.domSanitizer.sanitize(SecurityContext.HTML, this.priceRealAmountPipe.transform(amount.value, currency)),
                date: amount.date
            });
    }
}